import React from 'react';
import { DeviceEventsJournal } from '../devices/DeviceEventsJournal';

export const AdminDeviceEvents: React.FC = () => <DeviceEventsJournal audience="admin" />;
